import React from 'react';
import { Box, TextField, Popover } from '@mui/material';
import { ChromePicker } from 'react-color';

export function ColorPicker({ label, value, onChange }) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  return (
    <Box>
      <TextField
        label={label}
        value={value}
        onClick={(e) => setAnchorEl(e.currentTarget)}
        InputProps={{
          startAdornment: (
            <Box
              sx={{
                width: 24,
                height: 24,
                backgroundColor: value,
                borderRadius: '4px',
                mr: 1,
                border: '1px solid #ddd'
              }}
            />
          )
        }}
        fullWidth
      />
      
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
      >
        <ChromePicker
          color={value}
          onChangeComplete={(color) => onChange(color.hex)}
        />
      </Popover>
    </Box>
  );
}